BaseManager = require 'BaseManager'
eventManager = require 'eventManager'
log = require 'loglevel'

###############################################

class RealityManager extends BaseManager

  name: 'RealityManager'
  elapsed: 0
  started: false
  startTime: null
  needsToShowRealityCheck: false
  allowedToShowRealityCheck: false

  # -------------------------------------------

  constructor: ->
    log.info @constructor.name, 'constructor'

    super()

  #----------------------

  setCheckIntveral: (ms)->
    @intervalInMs = ms

  #----------------------

  start: (ms) ->

    return if @started

    @setCheckIntveral(ms) if ms?

    log.info @constructor.name, 'start'

    @started = true
    @startTime = new Date().getTime()
    @lastTime = @startTime
    @loopInterval()

  #----------------------

  loopInterval: ->

    log.info @name, 'realityCheck new loop', @intervalInMs

    window.setInterval( =>

      @currentTime = new Date().getTime()
      @elapsed = @currentTime - @lastTime

      if @elapsed > @intervalInMs
        log.info @name, 'realityCheck Fired', @elapsed
        @lastTime = new Date().getTime()
        @tryToShowRealityCheck()
    , 10000) #10 seconds

    true

  #----------------------

  canShowRealityCheck: (@allowedToShowRealityCheck) ->
    # log.info @constructor.name, 'canShowRealityCheck', @allowedToShowRealityCheck

    if @allowedToShowRealityCheck and @needsToShowRealityCheck
      @displayRealityCheck()
      return true
    false

  #----------------------

  tryToShowRealityCheck: ->

    if not @allowedToShowRealityCheck
      @needsToShowRealityCheck = true
      return

    @displayRealityCheck()

  #----------------------

  displayRealityCheck: ->

    @needsToShowRealityCheck = false

    now = new Date().getTime()
    duration = now - @startTime
    timeObj = @msToTime duration

    xHours = __t.str "%{smart_count} hours",
      smart_count: timeObj.hours

    xMins = __t.str "%{smart_count} mins",
      smart_count: timeObj.minutes

    msg = __t.str "You have been playing for %{xHours} and %{xMins}" ,
      xHours: xHours
      xMins: xMins

    eventManager.trigger 'reality', msg

  #----------------------

  msToTime: (milli) ->

    hours = parseInt(milli / (1000 * 60 * 60))
    mins = Math.round(milli / 1000 / 60) % 60

    res =
      hours: hours
      minutes: mins
    res

  #----------------------

module.exports = RealityManager.getInstance()



// WEBPACK FOOTER //
// ./coffee/manager/reality-manager.coffee